module.exports = __webpack_public_path__ + "static/img/YSM.11c2ffe.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/YSM.png
// module id = 7JBm
// module chunks = 1